import { render } from "./Subscribe.vue?vue&type=template&id=85ed8eb8&scoped=true"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import "./Subscribe.vue?vue&type=style&index=0&id=85ed8eb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ed8eb8"]])

export default __exports__